export const avatarColors = [
    "#253a5e",
    "#25562e",
    "#7a4841",
    "#884b2b",
    "#752438",
    "#402751",
    "#10141f"
]